import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import GTRModal from './GTRModal';
import User from './User';

class UserModal extends Component {
  render() {
    const { history } = this.props;
    return (
      <GTRModal history={history}>
        <User {...this.props} />
      </GTRModal>
    );
  }
}

export default UserModal;